/**
 * Utility functions for converting between 'YYYY-MM-DD' query date strings and
 * local-midnight Date objects, without going through UTC.
 */

/**
 * Parses a 'YYYY-MM-DD' string as local midnight on that calendar day.
 * Never use `new Date(str)` for this: a bare 'YYYY-MM-DD' string parses as
 * UTC midnight, which local getters then read as the previous day.
 * @param {string} dateString - Date in 'YYYY-MM-DD' format
 * @returns {Date} - Date at local midnight on that calendar day
 */
export const parseLocalDate = (dateString) => {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
};

/**
 * Formats a Date as 'YYYY-MM-DD' using local getters.
 * Never use `toISOString()` for this: it renders in UTC, which is a
 * different calendar day than the local one whenever the offset crosses
 * midnight.
 * @param {Date} date - Date to format
 * @returns {string} - Date in 'YYYY-MM-DD' format
 */
export const formatLocalDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
